import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tache text-regular" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["icons", {
        success: _ctx.tache.succes === true,
        error: _ctx.tache.succes === false,
      }])
    }, [
      _renderSlot(_ctx.$slots, "icons")
    ], 2),
    _renderSlot(_ctx.$slots, "libelle", {}, () => [
      _createElementVNode("div", null, _toDisplayString(_ctx.tache.type_tache_verbose), 1)
    ]),
    _createElementVNode("div", null, _toDisplayString(_ctx.$moment(_ctx.tache.date_traitement || _ctx.tache.date_creation).format(_ctx.$t("global.format-date-hour"))), 1)
  ]))
}